import { scrollThin } from "../../../../styles/g-grid-v2/components/scrollbarSelect";
const customHeight = "16.8px";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "transparent",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderColor: "#c8c8c8",
    boxShadow: state.isFocused ? null : null,
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: '#757575'
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
    padding: "0 0px",
    fontSize: 10,
    textAlign: "center",
    color: "gray"
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    padding: "3px 0",
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  }),

  placeholder: (provided: any, state: any) => {
    return {
      display: "none"
    }
  }
};

const customStylesPartner = (color: string, fontSize: number) => ({
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "transparent",
    minHeight: customHeight,
    height: customHeight,
    border: "none",
    boxShadow: state.isFocused ? null : null,
  }),

  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: color || "black"
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: customHeight,
    padding: "0 0px",
    fontSize: fontSize || 11,
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  }),

  placeholder: (provided: any, state: any) => ({
    ...provided,
    display: "block",
    color: "#C0C0C0"
  })
});

export const styles = {
  customStyles,
  customStylesPartner
}
